import {
  Box,
  Button,
  FormHelperText,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Stack,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";

import * as Yup from "yup";
import { useFormik } from "formik";
import {
  useAddAddressApiMutation,
  useGetSiteSettingApiQuery,
} from "../../../../../../Store/Slices/rtk";
import { notify } from "../../../../../../App";

export default function AddAdressModal({
  refetchGet,
  openModal,
  setOpenModal,
}) {
  const theme = useTheme();
  const [addAddressApi, { isLoading }] = useAddAddressApiMutation();

  const { data, isSuccess } = useGetSiteSettingApiQuery();
  const states = data?.data?.province;

  //  Yup
  const validationSchema = Yup.object().shape({
    city: Yup.string()
      .required("وارد کردن شهر الزامی است")
      .test("max-5-words", "لطفاً حداکثر ۵ کلمه وارد کنید", (value) => {
        if (!value) return false;
        const wordCount = value
          .trim()
          .split(/\s+/)
          .filter((w) => w.length > 0).length;
        return wordCount <= 5;
      }),
    state: Yup.string()
      .required("وارد کردن استان الزامی است")
      .test("max-5-words", "لطفاً حداکثر ۵ کلمه وارد کنید", (value) => {
        if (!value) return false;
        const wordCount = value
          .trim()
          .split(/\s+/)
          .filter((w) => w.length > 0).length;
        return wordCount <= 5;
      }),
    country: Yup.string(),
    postal_code: Yup.string()
      .required("وارد کردن کدپستی الزامی است")
      .matches(/^\d{10}$/, "کدپستی باید فقط شامل عدد باشد")
      .max(10, "کدپستی باید ۱۰ رقم باشد"),
    address_line: Yup.string().required("وارد کردن آدرس الزامی است"),
    name: Yup.string()
      .required("نام محل الزامی است")
      .test("max-3-words", "لطفاً حداکثر سه کلمه وارد کنید", (value) => {
        if (!value) return false;
        const wordCount = value
          .trim()
          .split(/\s+/)
          .filter((w) => w.length > 0).length;
        return wordCount <= 3;
      }),
  });

  // Formik
  const formik = useFormik({
    initialValues: {
      city: "",
      state: "",
      country: "iran",
      postal_code: "",
      address_line: "",
      name: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        await addAddressApi(values);
        refetchGet();
        setOpenModal(false);
        resetForm();
        notify("آدرس با موفقیت ثبت شد");
      } catch (error) {
        notify("مشکلی در ثبت آدرس پیش آمد ! مجدد تلاش کنید", "error");
      }
    },
  });

  const textFieldsStyle = {
    borderRadius: "8px",
    width: "100%",
    height: { xs: "38px", sm: "40px", md: "50px" },
    input: {
      color: theme.palette.primary.main,
      direction: "rtl",
    },
    bgcolor: "transparent",
    "& .MuiOutlinedInput-root": {
      height: {
        xs: "36px",
        sm: "40px",
        md: "50px",
      },
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: "8px",
      "&.Mui-focused fieldset": {
        border: `1px solid ${theme.palette.primary.main}`,
      },
      "& .MuiFormHelperText-root": {
        textAlign: "right !important",
        color: "gold",
        direction: "rtl !important",
      },
    },
  };

  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          direction: "rtl",
          position: "relative",
          display: "flex",
          gap: "2rem",
          alignItems: "center",
          background: theme.palette.background.paper,
          flexDirection: "column",

          width: {
            xs: "300px",
            sm: "400px",
            md: "600px",
            lg: "700px",
            xl: "800px",
          },
          borderRadius: "8px",
          p: 4,
        }}
      >
        {/* backGround */}
        {/* <Box
          sx={{
            position: "absolute",
            // zIndex: "-10",
            width: {
              xs: "300px",
              sm: "400px",
              md: "600px",
              lg: "700px",
              xl: "800px",
            },
           height: {
              xs: "300px",
              sm: "400px",
              md: "600px",
              lg: "700px",
              xl: "800px",
            },
          }}
        >
          <img
            style={{
              width: "100%",
              height: "100%",
            }}
            src="/media/Pages/Main/Cart/ConfirmCart/BackGround.png"
            alt="backgroundimage"
          />
        </Box> */}

        {/* City And State Inputs */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={{ width: "100%" }}
          gap="16px"
        >
          <Stack direction="column" spacing="4px" sx={{ width: "100%" }}>
            <InputLabel
              id="state-label"
              sx={{
                color: theme.palette.background.white,
                textAlign: "right",
                direction: "rtl",
              }}
            >
              استان
            </InputLabel>
            <Select
              labelId="state-label"
              name="state"
              value={formik.values.state}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.state && Boolean(formik.errors.state)}
              displayEmpty
              sx={{
                ...textFieldsStyle,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor:
                    formik.touched.state && formik.errors.state
                      ? "red"
                      : theme.palette.primary.main,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: theme.palette.primary.main,
                },
                "& .MuiSelect-select": {
                  color: theme.palette.primary.main,
                  direction: "rtl",
                  height: { xs: "36px", sm: "40px", md: "50px" },
                  display: "flex",
                  alignItems: "center",
                  padding: "0 14px",
                },
              }}
              inputProps={{ "aria-label": "state select" }}
            >
              <MenuItem value="" disabled>
                انتخاب استان
              </MenuItem>
              {states?.["مازندران"]
                ? Object.keys(states)?.map((st) => (
                    <MenuItem key={st} value={st}>
                      {st}
                    </MenuItem>
                  ))
                : null}
            </Select>
            {formik.touched.state && formik.errors.state && (
              <FormHelperText
                sx={{ textAlign: "right", color: "red", direction: "rtl" }}
                error
              >
                {formik.errors.state}
              </FormHelperText>
            )}
          </Stack>
          <Stack direction="column" spacing="4px" sx={{ width: "100%" }}>
            <InputLabel
              id="state-label"
              sx={{
                color: theme.palette.background.white,
                textAlign: "right",
                direction: "rtl",
              }}
            >
              شهر
            </InputLabel>
            <Select
              labelId="city-label"
              name="city"
              value={formik.values.city}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.city && Boolean(formik.errors.city)}
              displayEmpty
              sx={{
                ...textFieldsStyle,
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor:
                    formik.touched.city && formik.errors.city
                      ? "red"
                      : theme.palette.primary.main,
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: theme.palette.primary.main,
                },
                "& .MuiSelect-select": {
                  color: theme.palette.primary.main,
                  direction: "rtl",
                  height: { xs: "36px", sm: "40px", md: "50px" },
                  display: "flex",
                  alignItems: "center",
                  padding: "0 14px",
                },
              }}
              inputProps={{ "aria-label": "state select" }}
            >
              <MenuItem value="" disabled>
                انتخاب شهر
              </MenuItem>
              {states?.["مازندران"]
                ? states?.[formik?.values?.state]?.map((st) => (
                    <MenuItem key={st} value={st}>
                      {st}
                    </MenuItem>
                  ))
                : null}
            </Select>
            {formik.touched.state && formik.errors.state && (
              <FormHelperText
                sx={{ textAlign: "right", color: "red", direction: "rtl" }}
                error
              >
                {formik.errors.state}
              </FormHelperText>
            )}
          </Stack>
        </Stack>

        {/* Address Line */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={{ width: "100%" }}
          gap="16px"
        >
          <Stack direction="column" spacing="4px" sx={{ width: "100%" }}>
            <Typography sx={{ color: theme.palette.background.white }}>
              آدرس
            </Typography>
            <TextField
              inputProps={{
                autoComplete: "off",
                spellCheck: "false",
              }}
              name="address_line"
              value={formik.values.address_line}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.address_line &&
                Boolean(formik.errors.address_line)
              }
              helperText={
                formik.touched.address_line && formik.errors.address_line
              }
              sx={{
                ...textFieldsStyle,
                "& .MuiFormHelperText-root": {
                  textAlign: "right",
                  color:
                    formik.touched.name && formik.errors.name
                      ? "red"
                      : theme.palette.background.white,
                  direction: "rtl",
                },
              }}
            />
          </Stack>
        </Stack>

        {/* Post Code And Place Name */}
        <Stack
          direction={{ xs: "column", md: "row" }}
          sx={{ width: "100%" }}
          gap="16px"
        >
          <Stack direction="column" spacing="4px" sx={{ width: "100%" }}>
            <Typography sx={{ color: theme.palette.background.white }}>
              کدپستی
            </Typography>
            <TextField
              inputProps={{
                autoComplete: "off",
                spellCheck: "false",
              }}
              name="postal_code"
              value={formik.values.postal_code}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.postal_code && Boolean(formik.errors.postal_code)
              }
              helperText={
                formik.touched.postal_code && formik.errors.postal_code
              }
              sx={{
                ...textFieldsStyle,
                "& .MuiFormHelperText-root": {
                  textAlign: "right",
                  color:
                    formik.touched.name && formik.errors.name
                      ? "red"
                      : theme.palette.background.white,
                  direction: "rtl",
                },
              }}
            />
          </Stack>
          <Stack direction="column" spacing="4px" sx={{ width: "100%" }}>
            <Typography sx={{ color: theme.palette.background.white }}>
              نام محل
            </Typography>
            <TextField
              inputProps={{
                autoComplete: "off",
                spellCheck: "false",
              }}
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={
                formik.touched.name && formik.errors.name
                  ? formik.errors.name
                  : "مثال: محل کار"
              }
              sx={{
                ...textFieldsStyle,
                "& .MuiFormHelperText-root": {
                  textAlign: "right",
                  color:
                    formik.touched.name && formik.errors.name
                      ? "red"
                      : theme.palette.background.white,
                  direction: "rtl",
                },
              }}
            />
          </Stack>
        </Stack>

        {/* Submit Button */}
        <Button
          type="submit"
          size="large"
          variant="contained"
          disabled={isLoading || !formik.isValid}
          sx={{
            bgcolor: theme.palette.primary.main,
            color: "white",
            fontWeight: "bold",
            width: { xs: "100%", md: "50%", borderRadius: "8px" },
          }}
        >
          {isLoading ? "در حال ثبت..." : "ثبت"}
        </Button>
      </Box>
    </Modal>
  );
}
